import { useState } from 'react';
import { Bug, X, Send, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { sendUserReport } from '../utils/errorMonitor';

/**
 * Plywajacy przycisk "Zglos blad" w prawym dolnym rogu (nad Toaster).
 * Otwiera modal z formularzem opisu problemu + email kontaktowy.
 */
export function FeedbackButton() {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e?.preventDefault?.();
        const trimmed = message.trim();
        if (trimmed.length < 3) {
            toast.error('Opisz problem (min. 3 znaki)');
            return;
        }
        setSending(true);
        try {
            await sendUserReport({
                message: trimmed,
                contact_email: email.trim() || null,
            });
            toast.success('Dzieki! Zgloszenie zarejestrowane.');
            setMessage('');
            setEmail('');
            setOpen(false);
        } catch (err) {
            toast.error('Nie udalo sie wyslac zgloszenia. Sprobuj ponownie.');
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                title="Zglos blad lub problem"
                aria-label="Zglos blad"
                style={{
                    position: 'fixed',
                    bottom: '88px',
                    right: '16px',
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9998,
                }}
            >
                <Bug size={22} />
            </button>

            {open && (
                <div
                    onClick={() => !sending && setOpen(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '16px',
                    }}
                >
                    <form
                        onClick={(e) => e.stopPropagation()}
                        onSubmit={submit}
                        style={{
                            background: 'white',
                            borderRadius: '12px',
                            width: '100%',
                            maxWidth: '480px',
                            padding: '20px',
                            boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                            fontFamily: 'system-ui, sans-serif',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                            <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: 0 }}>
                                Zglos blad / sugestie
                            </h3>
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                disabled={sending}
                                style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px' }}
                            >
                                <X size={20} color="#64748b" />
                            </button>
                        </div>

                        <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '12px' }}>
                            Opisz co nie dziala lub co chcialbys zmienic. Aktualny adres strony zostanie dolaczony automatycznie.
                        </p>

                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Co sie stalo? Co probowales zrobic?"
                            rows={5}
                            maxLength={2000}
                            required
                            disabled={sending}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                border: '1px solid #cbd5e1',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                resize: 'vertical',
                                marginBottom: '12px',
                                boxSizing: 'border-box',
                            }}
                        />

                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Twoj email (opcjonalnie, dla kontaktu zwrotnego)"
                            disabled={sending}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                border: '1px solid #cbd5e1',
                                borderRadius: '8px',
                                fontSize: '14px',
                                marginBottom: '16px',
                                boxSizing: 'border-box',
                            }}
                        />

                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                disabled={sending}
                                style={{
                                    padding: '8px 16px',
                                    background: 'transparent',
                                    border: '1px solid #cbd5e1',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                }}
                            >
                                Anuluj
                            </button>
                            <button
                                type="submit"
                                disabled={sending}
                                style={{
                                    padding: '8px 16px',
                                    background: '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: sending ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                }}
                            >
                                {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
                                Wyslij
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </>
    );
}

export default FeedbackButton;
